<template>
  <pt-trust-deed-detail class="pt-trust-deed-detail__page" :id="id"></pt-trust-deed-detail>
</template>

<script>
import PtTrustDeedDetail from 'cps/trust-deed/pt-trust-deed-detail/withData'
export default {
  name: 'pt-trust-deed-detail__view',
  components: {
    'pt-trust-deed-detail': PtTrustDeedDetail
  },
  props: {
    id: {
      type: String,
      required: true
    },
  }
}
</script>
